import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { loadAuthFromStorage } from '../utils/helpers/authStorage';
import { achievementsReducer } from './achievements/achievementsReducer';
import { adRewardReducer } from './adReward/adRewardReducer';
import { authReducer, AuthState, initialState } from './auth/authReducer';
import { bonusReducer } from './bonus/bonusReducer';
import { duelsReducer } from './duels/duelsReducer';
import { friendsReducer } from './friends/friendsReducer';
import { i18nReducer } from './i18n/i18nReducer';
import { iapReducer } from './iap/iapReducer';
import { inviteReducer } from './invites/inviteReducer';
import invitesSlice from './invites/inviteSlice';
import { miniGamesRewardsReducer } from './jackpot/miniGamesRewardsReducer';
import { lobbyReducer } from './lobby/lobbyReducer';
import { miniGamesReducer } from './miniGames/miniGamesReducer';
import { missionsReducer } from './missions/missionsReducer';
import { packageReducer } from './packages/packagesReducer';
import { rankingsReducer } from './rankings/rankingsReducer';
import { roomReducer } from './room/roomReducer';
import { rootSaga } from './rootSaga';
import { tournamentsReducer } from './tournaments/tournamentsReducer';
import { notificationsReducer } from './userNotifications/notificationsReducer';
const saga = createSagaMiddleware();

const preloadedAuth: AuthState = {
	...initialState,
	...loadAuthFromStorage(),
};
const preloadedState = {
	auth: preloadedAuth,
};

export const store = configureStore({
	reducer: {
		room: roomReducer,
		auth: authReducer,
		lobby: lobbyReducer,
		package: packageReducer,
		bonus: bonusReducer,
		i18n: i18nReducer,
		notifications: notificationsReducer,
		invites: inviteReducer,
		activePlayers: invitesSlice,
		rankings: rankingsReducer,
		tournaments: tournamentsReducer,
		miniGames: miniGamesReducer,
		miniGamesRewards: miniGamesRewardsReducer,
		iap: iapReducer,
		adReward: adRewardReducer,
		missions: missionsReducer,
		friends: friendsReducer,
		achievements: achievementsReducer,
		duels: duelsReducer,
	},
	middleware: getDefault => getDefault({ thunk: false }).concat(saga),
	devTools: process.env.NODE_ENV !== 'production',
	preloadedState,
});

saga.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
